import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ClientLpTranslator } from '../clientLp.translator';
import { ClientLpAction } from '../clientLp.action';

type IDependencies = IClientApiDependencySegment;

export const loadClientLpListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ClientLpAction.loadList.started),
  mergeMap(() => {
    return dependencies.api.getLpList().pipe(
      mergeMap((response) => {
        const result = (response.lps ?? []).map(ClientLpTranslator.fromApi);

        return [
          ClientLpAction.loadList.done({ result }),
        ];
      }),
      catchApiError((error) => {
        return [
          ClientLpAction.loadList.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
